import { mapState, mapActions } from 'vuex';

export default {
  name: 'MachineProxyTest',
  props: {
    machineName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapState('machines', {
      machineProxyTestResult: ({ machineProxyTestResult }) => JSON
        .stringify(machineProxyTestResult, null, '\t'),
    }),
  },
  methods: {
    ...mapActions('machines', ['runMachineProxyTest']),
    async doMachineProxyTest() {
      this.$VBlackerTheme.openLoadingSpinner();
      try {
        await this.runMachineProxyTest({
          machineName: this.machineName,
        });
        this.dialog = true;
      } catch (e) {
        this.$VBlackerTheme.notification.error(e);
      } finally {
        this.$VBlackerTheme.closeLoadingSpinner();
      }
    },
  },
};
